<template>
  <div class="d-flex" style="min-height: 45vw;">
    <div class="content p-4 w-100">
      <div class="d-flex justify-content-between mb-1">
        <h4 class="card-title mt-0">{{ title }}</h4>
      </div>
      <div class="mb-5 d-flex justify-end">
        <div style="width: fit-content;" >
          <div class="btn-area">
            <create_modal
              v-if="createAuthority"
              :item="{}"
              @updateItem="searchSpotList"
              :showFlash="showFlash"
              :isCreateAuthority="createAuthority"
              :isOperationOffice="isOperationOffice"
              :isSubManagementOffice="isSubManagementOffice"
            >
            </create_modal>
          </div>
        </div>
        <v-btn
          v-show="csvtAuthorities.csvImport"
          class="exec-btn mt-0 ml-1"
          @click="activateModalState"
          >
          {{ i18n.global.t('pages.spot.csv.upload') }}
        </v-btn>
        <UpsertCsvButtons
          v-if="csvtAuthorities.csvImport || csvtAuthorities.csvExport"
          :title="$t('pages.common.button.csvUpsert')"
          :importTitle="$t('pages.spot.csv.importTitle')"
          :importType="importType"
          :exportType="exportType"
          :filterItems="makeSearchParams()"
          :getList="getSpots"
          :authorities="csvtAuthorities"
          elementId="spots-upsert"
        />
      </div>
      <div>
        <SpotList
          class="mb-2"
          :pageInfo="pageInfo"
          :items="dataList"
          :listLoading="listLoading"
          @changeItem="searchSpotList"
          :showFlash="showFlash"
          :isdeleteAuthority="deleteAuthority"
          :isUpdateAuthority="updateAuthority"
          :isOperationOffice="isOperationOffice"
          :isSubManagementOffice="isSubManagementOffice"
          :isManagementOffice="isManagementOffice"
          :isSearchCompleted="isSearchCompleted"
        />
        <PaginateWithCount
          class="justify-end"
          :totalPage="totalPage"
          v-model="currentPage"
          :itemsPerPage="itemsPerPage"
          :allElementsCount="allElementsCount"
          :showItemCount="true"
        />
      </div>
    </div>

    <SearchForm
      :loading="searchLoading"
      :isOperationOffice="isOperationOffice"
      :isSubManagementOffice="isSubManagementOffice"
      :isManagementOffice="isManagementOffice"
      @formchange="handleChangeSerarchForm"
      @search="searchSpotList"
    />
    <FileUploadModal
      :modalState="modalState"
      :title="i18n.global.t('pages.spot.csv.upload')"
      uploadBtnClass='exec-btn mt-0 ml-1'
      closeBtnClass='mt-0'
      :type="uploadType"
      templateCsvFileType="spots"
      @closeModal="inactivateModalState"
    >
    <template v-slot:supplementary-message>
      <div v-if="isManagementOffice || isSubManagementOffice">
        {{ i18n.global.t('pages.spot.csv.settingId') }}
        <span class="sample-file-download" style="color: #3C8DBC" @click="moveToOperationOfficePage()">
          {{ i18n.global.t('pages.spot.csv.here') }}
        </span>
        {{ i18n.global.t('pages.spot.csv.seeIdList') }}
      </div>
      <div v-if="isOperationOffice || isDepartment">
        {{ i18n.global.t('pages.spot.csv.currentLoginId', {operationOfficeId: operationOfficeId}) }}
      </div>
    </template>
    </FileUploadModal>
  </div>
</template>

<script>
  import SearchForm from "@/components/SpotParts/SpotSearchForm"
  import SpotList from "@/components/SpotParts/SpotList"
  import Api from "@/services/api/ApiServiceFabrick";
  import PaginateWithCount from "@/components/PaginateWithCount.vue"
  import CreateModal from "@/components/SpotParts/SpotCreateModal"
  import FileUploadModal from "@/components/Files/UploadModal"
  import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
  import {ref} from 'vue'
  import { useAuth } from "@/services/user/Auth0UserProvider"
  import UpsertCsvButtons from "@/components/Common/UpsertCsvButtons"
  import i18n from '@/lang/i18n';
  import { MANAGEMENT_OFFICE_TYPE, SUB_MANAGEMENT_OFFICE_TYPE, OPERATION_OFFICE_TYPE, DEPARTMENT_OFFICE_TYPE } from "@/services/consts";

  export default {
    props: {
      showFlash: {
        type: Function
      }
    },
    data() {
      return {
        title: i18n.global.t('pages.spot.title'),
        form: {},
        currentPage: 1,
        totalPage: 0,
        itemsPerPage: 50,
        allElementsCount: 0,
        dataList: [],
        selectedDeliveryPlanIds: [],
        selectOutputOptions: {},
        searchLoading: false,
        listLoading: false,
        beforeSearchParams: null,
        uploadType: "App\\Services\\Csv\\Imports\\SpotService",
        modalState: ref(false),
        isOperationOffice: ref(false),
        isSubManagementOffice: ref(false),
        isManagementOffice: ref(false),
        isDepartment: ref(false),
        operationOfficeId: ref(),
        importType: "UpsertImportSpot",
        exportType: "UpsertExportSpot",
        createAuthority: false,
        updateAuthority: false,
        deleteAuthority: false,
        csvtAuthorities: {
          csvImport: false,
          csvExport: false
        },
        isSearchCompleted: false,
      }
    },
    setup() {
      const { loginWithRedirect } = useAuth();
      return {
        loginWithRedirect,
        i18n
      }
    },
    mounted() {
      document.title = this.title;
      this.getAuthorities()
      Api().getSelfAccount().then((data) => {
        this.isManagementOffice = data.login_organization_type == MANAGEMENT_OFFICE_TYPE
        this.isSubManagementOffice = data.login_organization_type == SUB_MANAGEMENT_OFFICE_TYPE
        this.isOperationOffice = data.login_organization_type == OPERATION_OFFICE_TYPE
        this.isDepartment = data.login_organization_type == DEPARTMENT_OFFICE_TYPE
        if (this.isOperationOffice || this.isDepartment) {
          this.operationOfficeId = data.officeable_id;
        }
        const id = this.$route.query.id
        if (id) {
          this.form = { ...this.form, id }
          return this.getSpots()
        }
        if (!this.isManagementOffice) {
          this.getSpots()
        }
      })
    },
    watch: {
      currentPage: {
        handler() {
          this.getSpots(this.currentPage, false)
        }
      }
    },
    methods: {
      async getAuthorities() {
        const authorityList = await AuthorityCacheApi.getWithParse();
        this.createAuthority = !!authorityList["octlink.spot.create"];
        this.updateAuthority = !!authorityList["octlink.spot.update"];
        this.deleteAuthority = !!authorityList["octlink.spot.delete"];
        this.csvtAuthorities.csvImport = !!authorityList["octlink.spot.input"];
        this.csvtAuthorities.csvExport = !!authorityList["octlink.spot.output"];
      },
      handleChangeSerarchForm(form) {
        this.form = form
      },
      handleSelectDeliveryPlanId(selectedDeliveryPlanIds) {
        this.selectedDeliveryPlanIds = selectedDeliveryPlanIds
      },
      searchSpotList() {
        this.searchLoading = true
        this.getSpots()
      },
      getSpots(page = 1, updateOption = true) {
        this.listLoading = true
        let req
        if (updateOption || !this.beroreSearchParams) {
          req = this.makeSearchParams(page)
          this.beroreSearchParams = req
        } else {
          req = this.beroreSearchParams
          req.page = page
        }

        Api().getSpots(req).then((data) => {
          this.dataList = data.items
          this.currentPage = data.current_page
          this.totalPage = data.total_page
          this.allElementsCount = data.total
          this.itemsPerPage = data.per_page
          this.searchLoading = false
          this.listLoading = false
          this.isSearchCompleted = true
        }).catch((error) => {
          const res = error.response
          switch (res.status) {
            case 401:
              this.loginWithRedirect({ appState: { targetUrl: location.pathname } })
              break
            case 403:
              location.reload()
              break
            case 422:
              this.showFlash(i18n.global.t('pages.spot.errors.getList'), "error", false)
          }
          this.listLoading = false
          this.searchLoading = false
        })
      },
      makeSearchParams(page){
        const ret = {
          page: page,
          operation_office_id: this.form?.operationOffice?.id,
          management_officeable_id: this.form?.managementOffice?.id,
          management_officeable_type: this.form?.managementOffice?.type,
          name: this.form?.name,
          address: this.form?.address,
          id: this.form?.id,
        }
        return ret
      },
      convertDateTimeTodate(datetime) {
        const ret = datetime?.toISOString() || ''
        return ret.split('T')[0].replaceAll('-', '/')
      },
      inactivateModalState (isReacquireGroup) {
        this.modalState = false
        if (isReacquireGroup) this.getSpots()
      },
      activateModalState () {
        this.modalState = true
      },
      moveToOperationOfficePage () {
        this.$router.push('/operation-offices/')
      }
    },
    components: {
      SearchForm,
      SpotList,
      PaginateWithCount,
      create_modal: CreateModal,
      FileUploadModal,
      UpsertCsvButtons,
    }
  }
</script>

<style scoped>
.content {
  min-width: 58vw;
}
</style>
<style>
.main-panel {
  height: initial !important;
  max-height: initial !important;
}
.exec-btn {
  background-color: rgb(21, 130, 156);
  color: white !important;
}
.reset-btn {
  background-color: rgb(245, 246, 247);
  color: rgb(21, 130, 156) !important;
  font-weight: bold;
}
</style>
